import { httpsCallable } from "firebase/functions";
import { getStorage, ref, uploadBytes } from "firebase/storage";
import { getFirebaseFunctions } from "../../firebase.ts";
import type {
  FactoringInput,
  FactoringEntryInput,
  FactoringImageCreation,
  FactoringEntryCreation,
} from "components/factoringModel";

interface Request {
  desiredAmount: number;
  notes: string;
  personalInfoConsent: boolean;
  images: FactoringImageCreation[];
  entries: FactoringEntryCreation[];
}

interface Response {
  success: boolean;
  message: string;
}

export const createFactoring = async (
  userId: string,
  factoring: FactoringInput,
  entries: FactoringEntryInput[],
) => {
  const functions = getFirebaseFunctions();
  const storage = getStorage();

  const createFactoring = httpsCallable<Request, Response>(
    functions,
    "createFactoring",
  );

  const dirPrefix = `users/${userId}/factoring/${Date.now()}`;

  const uploadFilesPromise = entries.flatMap((entry) => {
    return entry.imageFiles.map(async (file, index) => {
      const filePath = `${dirPrefix}/${entry.id}-${index}-${file.name}`;
      const storageRef = ref(storage, filePath);

      // ファイルをアップロード
      await uploadBytes(storageRef, file);

      const factoringImage: FactoringImageCreation = {
        fileName: file.name,
        filePath,
        group: "0",
        entryId: entry.id,
      };

      return factoringImage;
    })
  });

  const uploadedImages: FactoringImageCreation[] = await Promise.all(uploadFilesPromise);

  const res = await createFactoring({
    desiredAmount: Number(factoring.desiredAmount),
    notes: factoring.notes,
    personalInfoConsent: factoring.personalInfoConsent,
    images: uploadedImages,
    entries: entries.map((entry) => {
      const { imageFiles, ...entryWithoutImageFiles } = entry;
      return entryWithoutImageFiles;
    })
  });
  return res.data;
};
